import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';

function ShibaPage() {
  const [shibaList, setShibaList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchShibaData = async () => {
      try {
        // const res = await axios.get("http://127.0.0.1:8000/api/subject_shiba");
        const res = await axios.get('/api/subject_shiba');
        setShibaList(res.data);
      } catch (error) {
        console.error('データ取得失敗:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchShibaData();
  }, []);

  if (loading) {
    return <div>読み込み中...</div>;
  }

  return (
    <Box p={4}>
      <Typography variant="h4" gutterBottom>
        期待値越え芝 一覧
      </Typography>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              {/* カラム名はデータに合わせて変更してOK */}
              <TableCell>会場</TableCell>
              <TableCell>レース番号</TableCell>
              <TableCell>馬番</TableCell>
              <TableCell>オッズ</TableCell>
              <TableCell>一着確率</TableCell>
              <TableCell>期待値</TableCell>
              <TableCell>対象</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {shibaList.map((shiba) => (
              <TableRow key={shiba.id}>
                <TableCell>{shiba.jyocd}</TableCell>
                <TableCell>{shiba.racenum}</TableCell>
                <TableCell>{shiba.umaban}</TableCell>
                <TableCell>{shiba.tansho_odds}</TableCell>
                <TableCell>{shiba.probability}%</TableCell>
                <TableCell>{shiba.hit_predict_persent}</TableCell>
                <TableCell>{shiba.prediction}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default ShibaPage;
